import React from 'react';
import PriceWidgetBuilder from './PriceWidgetBuilder';
import PriceWidgetRenderer from './PriceWidgetRenderer';
import Preview from './Preview';
import type { WidgetDefinition } from '../../../registry';
import type { PriceWidgetConfig } from './types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCoins } from '@fortawesome/free-solid-svg-icons';

export { default as PriceWidgetBuilder } from './PriceWidgetBuilder';
export { default as PriceWidgetRenderer } from './PriceWidgetRenderer';
export * from './types';

export const definition: WidgetDefinition = {
  type: 'price',
  meta: {
    label: 'Price',
    icon: React.createElement(FontAwesomeIcon, { icon: faCoins }),
    description: 'Historical price chart with volume from market data',
    isSystem: true,
    isCreatable: true,
    requiresAsset: true,
    dataFlow: 'display',
  },
  dataProvider: {
    widget: 'PRICE',
    params: [
      { key: 'horizon', label: 'Horizon', defaultValue: 504, unit: 'trading days', type: 'number', placeholder: '504' },
      { key: 'index', label: 'Comparison Index', defaultValue: '', unit: 'ticker', type: 'text', placeholder: 'e.g. SPY' },
    ],
  },
  defaultSize: { w: 8, h: 5, minW: 5, minH: 4 },
  defaultConfig: () => ({} as PriceWidgetConfig),
  Builder: PriceWidgetBuilder,
  Renderer: PriceWidgetRenderer,
  Preview,
};
